import UserComponent from "./UsersComponent"
import { users } from "../../../../Constants/Data"

const MainUsers = () => {
    return (
        <div className="w-full flex flex-col pb-[100px]">
            <div className="w-full mt-[64px]">
                <h2 className="w-full md:w-11/12 2xl:w-[1536px] 3xl:w-[2048px] md:mx-auto text-center text-usersTitle font-allroundgothic font-[600] text-[36px] 1.5xl:text-[59px] px-4 xs:px-[32px] md:px-4 ">
                    Unlock The Full Potential of Your EHR</h2>

                <p className="mt-[32px] w-full md:mx-auto font-proximanova text-[#505050] text-[18px] text-[#505050] px-[20px] xs:px-[32px] 1.5xl:px-[120px] 3xl:px-[280px]">
                    Apps, devices and AI powered innovations are constantly fueling advancements in healthcare. The CharmHealth marketplace brings these innovations directly to the fingertips of providers. Through CharmHealthHub, not only can you easily search and find the best applications for your practice, but also get in touch with consultants, billers, and developers that can work with our API program to build custom solutions.</p>
            </div>

            <div className="w-full mt-[32px] px-[20px] xs:px-[40px] 1.5xl:px-[112px] 3xl:px-[280px] grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-6 1.5xl:grid-cols-5 gap-[60px]">
                <div className="w-full sm:col-span-2 1.5xl:col-span-1">
                    <UserComponent
                        url={users[0].url}
                        user={users[0].user}
                        description={users[0].description}
                        link={users[0].link}
                    />
                </div>
                <div className="w-full sm:col-span-2 1.5xl:col-span-1">
                    <UserComponent
                        url={users[1].url}
                        user={users[1].user}
                        description={users[1].description}
                        link={users[1].link}
                    />
                </div>
                <div className="w-full sm:col-span-2 1.5xl:col-span-1">
                    <UserComponent
                        url={users[2].url}
                        user={users[2].user}
                        description={users[2].description}
                        link={users[2].link}
                    />
                </div>
                <div className="w-full hidden lg:block 1.5xl:hidden lg:col-span-1"></div>
                <div className="w-full sm:col-span-2 1.5xl:col-span-1">
                    <UserComponent
                        url={users[3].url}
                        user={users[3].user}
                        description={users[3].description}
                        link={users[3].link}
                    />
                </div>
                <div className="w-full hidden sm:block lg:hidden sm:col-span-1"></div>
                <div className="w-full sm:col-span-2 1.5xl:col-span-1">
                    <UserComponent
                        url={users[4].url}
                        user={users[4].user}
                        description={users[4].description}
                        link={users[4].link}
                    />
                </div>
            </div>
        </div>
    );
}

export default MainUsers;